import type { AiLandingPageSuggestion } from "@mirage/analytics/events/enums/ai_landing_page_suggestion";
import type { DashWriteTemplate } from "@mirage/analytics/events/enums/dash_write_template";
import type { Prompt_1 } from "@mirage/analytics/events/enums/prompt_1";
import type { Prompt_2 } from "@mirage/analytics/events/enums/prompt_2";
import type { Prompt_3 } from "@mirage/analytics/events/enums/prompt_3";

export const enum SuggestionType {
  STATIC = "static",
  DYNAMIC = "dynamic",
  CONTEXTUAL = "contextual",
  FSS_WRITE = "fss_write",
}

export const enum UserJourney {
  FTUX = "FTUX",
  ATUX = "ATUX",
}

// Union type for all PAP enum values (they all have the same values)
export type PAPPromptEnum =
  | Prompt_1
  | Prompt_2
  | Prompt_3
  | AiLandingPageSuggestion;

export type StaticSuggestion = {
  type: SuggestionType.STATIC;
  getSuggestionText: () => string;
  hasPrescribedAnswer?: boolean;
  enum?: PAPPromptEnum;
};

export type DynamicSuggestion = {
  type: SuggestionType.DYNAMIC;
  enum?: PAPPromptEnum;
};

export type ContextualSuggestion = {
  type: SuggestionType.CONTEXTUAL;
  getSuggestionText: () => string;
  enum?: PAPPromptEnum;
};

export type FssWriteSuggestion = {
  type: SuggestionType.FSS_WRITE;
  enum?: DashWriteTemplate;
};

export type Suggestion =
  | StaticSuggestion
  | DynamicSuggestion
  | ContextualSuggestion
  | FssWriteSuggestion;

export type NestedSurfaceEntry = { [extensionType: string]: Suggestion[] };
export type FlatSurfaceEntry = Suggestion[];
export type SurfaceEntry = NestedSurfaceEntry | FlatSurfaceEntry;

export type ChipsStateMap = {
  [userJourney in UserJourney]: {
    [surface: string]: SurfaceEntry;
  };
};
